import { useState, useEffect, useCallback } from 'react';
import { useWindowSize } from './useWindowSize';

export const PAGE_FILTER_BREAKPOINT = 991;

const getIsDesktop = (width) => {
  if (width === undefined) {
    return typeof window !== 'undefined' && window.innerWidth > PAGE_FILTER_BREAKPOINT;
  }
  return width > PAGE_FILTER_BREAKPOINT;
};

export const usePageFilter = () => {
  const windowSize = useWindowSize();
  const width = windowSize?.width;
  const isDesktop = getIsDesktop(width);

  const [isShowFilter, setIsShowFilter] = useState(() => getIsDesktop(undefined));
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const isFilterSidebarVisible = isShowFilter && isDesktop;

  useEffect(() => {
    if (width !== undefined && width <= PAGE_FILTER_BREAKPOINT) {
      setIsShowFilter(false);
    }
  }, [width]);

  const openFilter = useCallback((scrollTo) => {
    if (getIsDesktop(width)) {
      setIsShowFilter(true);
      scrollTo?.('filter');
    } else {
      setIsFilterModalOpen(true);
    }
  }, [width]);

  const closeFilterSidebar = useCallback(() => {
    setIsShowFilter(false);
  }, []);

  const closeFilterModal = useCallback(() => {
    setIsFilterModalOpen(false);
  }, []);

  const closeFilterOnMobile = useCallback(() => {
    if (!getIsDesktop(width)) {
      setIsFilterModalOpen(false);
    }
  }, [width]);

  const getTableColSize = useCallback((hasFilterData) => {
    return hasFilterData && isShowFilter && isDesktop ? 9 : 12;
  }, [isShowFilter, isDesktop]);

  const canShowFilterButton = useCallback((hasFilterData, hasResults = true) => {
    return hasFilterData && !isFilterSidebarVisible && hasResults;
  }, [isFilterSidebarVisible]);

  return {
    isShowFilter,
    setIsShowFilter,
    isFilterModalOpen,
    isDesktop,
    isFilterSidebarVisible: isShowFilter && isDesktop,
    openFilter,
    closeFilterSidebar,
    closeFilterModal,
    afterApplyFilter: closeFilterOnMobile,
    afterClearFilter: closeFilterOnMobile,
    getTableColSize,
    canShowFilterButton,
  };
};
